/**
 * The list of country field names in the ethos address models.
 */
const countries = [
    'australia',
    'brazil',
    'canada',
    'mexico',
    'netherlands',
    'unitedKingdomOfGreatBritainAndNorthernIreland',
    'unitedStatesOfAmerica',
    'generic',
];

/**
 * Utility to subtract given country field names from list.
 */
const countriesMinus = (minus = []) => {
    return countries.filter((c) => minus.indexOf(c) < 0);
};

module.exports = {
    countries,
    countriesMinus,
};
